import { render } from "./ProfilePage.vue?vue&type=template&id=5fb700b1"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"
script.render = render

export default script